// extracted by mini-css-extract-plugin
export default {"headerButton":"TreeHeaderComp_headerButton__aGluo"};